import { Type } from 'class-transformer';
import { FieldValueResultDto } from '../../../reports-module/_models/field-value-result-dto';
import { ExpenseBreakdownResultDto } from './expense-breakdown-result-dto';

export class ExpenseBreakdownReportResultDto {
    reportId: number;
    reportOutputType: string;

    @Type(() => FieldValueResultDto)
    reportParameters: Array<FieldValueResultDto>;

    @Type(() => ExpenseBreakdownResultDto)
    expenseBreakdowns: Array<ExpenseBreakdownResultDto>;
}
